import { api } from "../api";
import { DriverParameter } from "../../../types/types";

const findDriverParameterByDriverAndCustomer = async (
    token: string,
    driverId: number,
    customerId: number,
) => {
    const response = await api.get<DriverParameter>(
        `/driver-parameters/driver/${driverId}/customer/${customerId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );

    return response;
};

export default findDriverParameterByDriverAndCustomer;
